import { Environment } from './environment.model';

export const environment: Environment = {
    production: false,
    ws: {
        url: 'wss://rocket.imaxagaming.com:9779/n/00d4fb50b11b0d9d/d52c740a7d741e64/croupier',
        reconnectIntervalMs: 10000
    },
    version: 'local'
};
